import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import type { TopAreaBannerContext } from '../../context';
import { TOP_AREA_BANNER_HEIGHT } from './constants';

export const Root = styled('div', { shouldForwardProp: shouldForwardProp() })<
  Partial<Pick<TopAreaBannerContext, 'isOrderOnBehalfVisible'>>
>(({ isOrderOnBehalfVisible, theme, onClick }) => ({
  background: isOrderOnBehalfVisible ? theme.palette.blue[300] : theme.palette.offer.light,
  color: isOrderOnBehalfVisible ? theme.palette.common.white : theme.palette.offer.dark,
  cursor: onClick ? 'pointer' : 'default',
  display: 'flex',
  zIndex: theme.zIndex.appBar,
  height: TOP_AREA_BANNER_HEIGHT,
  width: '100vw',
  position: 'fixed',
  top: '0',
  left: '0',

  alignItems: 'center',
  justifyContent: 'center',
}));
